import { entityReport, SnakeMeta } from '@toggle/toggle';

import { parseEntityScreenerData } from '~/hooks/use-one-day-return-live-price/utils';
import { postEntity } from '~/services/entities/entity-service';
import { fetchSnakeMeta } from '~/services/overview-widget/overview-widget-service';
import { apiFetch } from '~/utils/api-fetch/apiFetch';
import { fetchFilteredEntities } from '~/widgets/scenario/hooks/use-screener-entities-tags/entity-screener-service/entity-screener-service';
import { mapEntityTagsToDefaultOptions } from '~/widgets/scenario/hooks/use-screener-entities-tags/useScreenerEntitiesTags';

export const getEntityValues = async (tag: string) => {
  const [entity, latestValues, entityScreener] = await Promise.all([
    postEntity(tag),
    apiFetch(entityReport.getEntityLatestValues.path(tag), {
      schema: entityReport.getEntityLatestValues.schema,
    }),
    fetchFilteredEntities(mapEntityTagsToDefaultOptions([tag])),
  ]);

  if (
    entity.error ||
    !entity?.data ||
    !latestValues?.data ||
    !entityScreener?.data
  ) {
    return undefined;
  }

  const snakeMeta: SnakeMeta | undefined = await (async () => {
    try {
      return await fetchSnakeMeta(entity.data.default_snake);
    } catch {
      return undefined;
    }
  })();

  const { liveReturn1D } = parseEntityScreenerData(entityScreener);

  return {
    entity: entity.data,
    latestValues: latestValues?.error ? {} : latestValues?.data,
    snakeMeta,
    liveReturn1D: liveReturn1D?.value,
  };
};
